import { FC } from "react";

export const MigratedBannerTitle: FC = () => <span>This work packet has been migrated</span>;

export const MigratedBannerBody: FC = () => (
  <>This work packet has been migrated out of CGOps and can no longer be updated here.</>
);
